module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/icon-call-4f89b4a9fbdf4ba3f572f290086db034.svg";